import React from 'react';
import Section from './Section';

const Skills = ({ skills = [] }) => {
  const groups = skills.length ? skills : [
    { title: 'Frontend', items: ['React', 'Next.js', 'TypeScript', 'Redux', 'Tailwind', 'Framer Motion'] },
    { title: 'Backend', items: ['Node.js', 'Express', 'REST', 'GraphQL'] },
    { title: 'Tools', items: ['Git', 'Vercel', 'Jest', 'Webpack', 'Figma'] },
  ];

  return (
    <Section id="skills" title="Skills" subtitle="What I use">
      <div className="grid three">
        {groups.map((g) => (
          <div key={g.title} className="card glass">
            <h3>{g.title}</h3>
            <ul className="tags">
              {g.items.map((s) => <li key={s}>{s}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Skills;
